import { allQuicksightDashboard } from '../queries';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

export function useAllQuicksightDashboard () {
  const { data: query , refetch: refresh, loading: isLoading } = useQuery(allQuicksightDashboard, {
    fetchPolicy: 'cache-first',
  });
  const data = (query?.allQuicksightDashboard?.edges.length) > 0 ? removeConnectionsMemoized(query?.allQuicksightDashboard) : [];
  return {
    data,
    refresh,
    isLoading
  };
}
